/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import React from "react";
import { appConstants } from "utils/appConstants";
const containerStyle = {
    width: '680px',
    height: '430px'
  };
const Map = (props) => {
    const [markerPosition, setMarkerPosition] = React.useState( props.cordinate);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: appConstants.googleAutoCommpleteKey
  })
  const [map, setMap] = React.useState(null)
  const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds( props.cordinate);
        console.log("asdasda" , bounds)
        map.fitBounds(bounds);
        setMap(map)
  }, []);
  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);
  const onMarkerDragEnd = (event) => {
    const { latLng } = event;
    const newMarkerPosition = {
      lat: latLng.lat(),
      lng: latLng.lng()
    };
    setMarkerPosition(newMarkerPosition);
    props.onCoordinateChange(newMarkerPosition);
  };
  return (
    <>    { isLoaded && props.cordinate ? 
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={props.cordinate}
          zoom={10}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          <></>
          <Marker
          position={markerPosition}
          title="Draggable Marker"
          draggable={true}
          onDragEnd={onMarkerDragEnd}
        />
        </GoogleMap>
     : <></>
        }
        </>
 );
    }
export default Map;